module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_johnshopkins-c37289b4c497583b6dcaf850bf917238.png";